<template>
  <div v-if="show">
    <div class="evolution">
      <div class="evolution_nav">
        <div class="editorial_txt">
          <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
          <div class="editorial_txt2" @click="tiao" style="cursor: pointer;">
            首页 <span class="span1">></span> <span class="span2">病例分享</span>
          </div>
        </div>
        <div class="editorial_left">
          <middlenav :middle="middle" :deeds="deeds" :cename="cename" :totalcount="totalcount" @currentPage3="currentPage3"></middlenav>
        </div>
        <div class="evolution_right">
          <advertisement :num="num" :list2="list2"></advertisement>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//配置中间内容栏
import middlenav from "../public/evolution/evolution_nav.vue"
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components: {
    advertisement,
    middlenav
  },
  data () {
    return {
      curr: 1,
      limit: 10,
      show: false,
      totalcount: 0,
      cename: '病例分享',
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      middle:{
        brief: false,//杂志简介
        inscription: false,//领导及专家题词
        Deeds: true,//发展大事记
        Awards: false,//获奖情况
        Included: false,//检索机构收录情况
        paper: false,//论文统计与分析
        blessing: false,//祝福集锦
        meeting: false,//编委会会议
      },//中间内容区域展示模块显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      deeds: [],//发展大事记
    }
  },

  methods:{
    tiao(){
      this.$router.push({path:'/home'});
    },
    //获取网站 首页模块信息 / 点击栏目得到的数据信息
    GetHomePageBlockInfo(){
      sessionStorage.setItem('routerIndex',0);
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": that.$_JournalId,
        "pChannelId": 0,
        "channelId": 0,
        "jChannelID": 1468,
        "dataSourceType": 3,
        "dataShowType": 1,
        "curr": that.curr,
        "limit": that.limit,
      }).then(res => {
        if(res.code==200){
          that.deeds = res.data || '';
          that.totalcount = res.totalcount;
          that.show = true;
          console.log(that.totalcount,'that.totalcount123');
          that.$loading.hideLoading();
        }else{
          that.show = true;
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      });
    },
    //翻页
    currentPage3(e){
      this.curr = e;
      this.GetHomePageBlockInfo();
    },
    //外科天地鼠标悬停
    addtop2(num,id){
      if(num==1){
        for(var i=0;i<this.list2.length;i++){
          if(id==this.list2[i].id){
            this.list2[i].zt = true;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.list2.length;i++){
          this.list2[i].zt = false;
          this.list2.push('1');
          this.list2.pop('1');
        }
      }
    },
  },
  created(){
    this.GetHomePageBlockInfo();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.evolution{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  margin-top: 24px;
  padding-bottom: 46px;
  .evolution_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .editorial_txt{
      width: 100%;
      // margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        .waike {
          width: 50%;
          float: left;
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          line-height: 23px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .evolution_right{
      width: 25%;
      float: left;
      padding-top: 40px;
      .express_right{
        width: 100%;
        margin-bottom: 50px;
        .express_rtitle{
          width: 100%;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          padding-bottom: 11px;
          position: relative;
          .waike{
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 23px;
          }
          .zi{
            width: 50%;
            float: right;
            text-align: right;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            cursor: pointer;
          }
          .waixian{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 81px;
            height: 3px;
            background: var(--biao);
          }
        }
        .express_rxia{
          width: 100%;
          .express_rimg{
            width: 100%;
            height: 199px;
            margin-top: 20px;
            margin-bottom: 27px;
            cursor: pointer;
          }
          .express_rimg:hover{
            transform: scale(1.05);
          }
          .express_rtxt{
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow:hidden;
            cursor: pointer;
          }
          .express_rlist{
            width: 100%;
            overflow: hidden;
            margin-top: 30px;
            margin-bottom: 21px;
            cursor: pointer;
            .express_dian{
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 15px;
              float: left;
              margin-top: 6px;
            }
            .wenben{
              width: 85%;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
            }
          }
        }
      }
      .Journalism_one{
      	width: 100%;
      	.Journalism_onetop{
      		width: 100%;
      		overflow: hidden;
          border-bottom: 2px solid #EEEEEE;
      		.Journalism_xian1{
      			width: 4px;
      			height: 21px;
      			background: var(--xt);
      			float: left;
            margin-right: 4px;
            margin-top: 7px;
      		}
      		.Journalism_xian2{
      			width: 2px;
      			height: 21px;
      			background: var(--xt);
      			float: left;
            margin-right: 12px;
            margin-top: 7px;
      		}
      		.Journalism_txt{
      			width: 24%;
            cursor: pointer;
      			font-size: 18px;
      			font-family: Source Han Sans SC;
      			font-weight: 400;
      			color: #000000;
      			line-height: 38px;
      			position: relative;
            text-align: center;
            float: left;
      			.Journalism_xian3{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
      				position: absolute;
      				right: 0;
              top: 14px;
      			}
      		}
      		.Journalism_right{
      			float: right;
      			width: 90px;
      			height: 12px;
      			font-size: 14px;
      			font-family: Source Han Sans SC;
      			font-weight: bold;
      			color: #878787;
      			line-height: 23px;
            cursor: pointer;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
      		}
      	}
        .Journalism_onebottom{
           width: 100%;
           overflow: hidden;
           margin-top: 19px;
          .Journalism_list{
            width: 100%;
            overflow: hidden;
            margin-bottom: 26px;
            .Journalism_listl{
              width: 40%;
              height: 119px;
              float: left;
              cursor: pointer;
            }
            .Journalism_listl:hover{
              transform: scale(1.05);
            }
            .Journalism_listr{
              width: 53%;
              float: left;
              margin-left: 2%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
			  overflow: hidden;
              a{
                font-size: 18px;
                font-family: Adobe Heiti Std;
                font-weight: bold;
                text-decoration: underline;
                line-height: 28px;
              }
              a:hover{
                color: var(--xt)!important;
              }
             .listr_xia{
               margin-top: 35px;
               span{
                 font-size: 14px;
                 font-family: Adobe Heiti Std;
                 font-weight: normal;
                 color: #757575;
                 line-height: 28px;
               }
             }
            }
          }
          .Journalism_list2{
            width: 100%;
            overflow: hidden;
            margin-bottom: 22px;
            .Journalism_list2id,.Journalism_list2id2{
              width: 5%;
              max-width: 20px;
              height: 20px;
              background: #E34919;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
              float: left;
              margin-right: 15px;
              color: #FFFFFF;
              margin-left: 2%;
            }
            .Journalism_list2id2{
              background-color: #D2D2D2;
            }
            .kandian{
              line-height: 20px;
              float: left;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              margin-right: 10px;
            }
            .Journalism_list2txt{
              width: 80%;
              font-size: 16px;
              line-height: 20px;
              font-family: Adobe Heiti Std;
              color: #000000;
              float: left;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
              cursor: pointer;
            }
          }
        }
      }

    }
  }
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.add2{
  background-color: var(--xt)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/sharing.vue